// extracted by mini-css-extract-plugin
module.exports = {"NotFoundError":"tg_a vh_ne vh_a vh_w vh_j vh_q","NotFoundError__icon":"tg_b vh_rl vh_fc vh_ox","NotFoundError__icon__image":"tg_c","NotFoundError__message":"tg_e vh_fc vh_ps"};